module.exports = __webpack_public_path__ + "img/jagopack-inactive.1372be43.svg";